/* eslint-disable camelcase */
import { FC } from 'react';

import { Heading, Loader, Text } from '@livechat/design-system-react-components';

import { Layout } from 'components/layout/Layout';
import { useGetMe } from 'hooks/use-get-me';
import { useOrganizations } from 'hooks/use-organizations';
import { useCanJoinToProduct } from 'hooks/use-can-join-to-product';
import { detectProduct, getProductName } from 'helpers/product';

import { AccessibleProductButton } from '../product-buttons/AccessibleProductButton';

import * as styles from './styles';

export const MAX_AVATARS_IN_GALLERY = 5;
export const MAX_ACCOUNTS_NO_FOR_COUNTER = 103;

type Props = {
  organizationId: string;
};

export const JoinProductBlocked: FC<Props> = ({ organizationId }) => {
  const currentProduct = getProductName(detectProduct());

  const { isFetching: isFetchingOrganizations, organizations } = useOrganizations();
  const { roles, isFetching: isFetchingMe } = useGetMe();
  const { isLCStarterPlan } = useCanJoinToProduct(currentProduct);

  const myOrgazanition = organizations.find(
    ({ organization_id }) => organization_id === organizationId
  );

  const rolesInCurrentOrganization = [
    ...new Set(
      roles
        ?.filter(
          ({ organization_id, role }) => organization_id === organizationId && role !== 'inviter'
        )
        ?.flatMap(({ product }) => product) ?? []
    ),
  ];

  if (isFetchingMe || isFetchingOrganizations) {
    return (
      <Layout showHeaderLogo showDropdown>
        <Loader size="large" />
      </Layout>
    );
  }

  return (
    <Layout showHeaderLogo showDropdown>
      <div css={styles.joinBlockedContainer}>
        <Heading css={styles.header} size="lg">
          {currentProduct} user limit reached
        </Heading>
        {isLCStarterPlan && <Text>The current LiveChat plan is designed for a single user.</Text>}
        <Text>
          {isLCStarterPlan
            ? 'Ask the Owner to upgrade to Team plan if you want to join LiveChat.'
            : 'Ask your partner to upgrade the subscription if you want to join LiveChat.'}
        </Text>
        {!!rolesInCurrentOrganization?.length && (
          <div css={styles.otherProducts}>
            <Text>Log in to the products you already have:</Text>
            <div>
              {rolesInCurrentOrganization.map((product) => (
                <AccessibleProductButton product={product} organization={myOrgazanition} />
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
